export default {
      id: "color_clock-usage",
      viewBox: "0 0 76 76",
      url: __webpack_public_path__ + "sprite.svg#color_clock",
      toString: function () {
        return this.url;
      }
    }